module.exports = __webpack_public_path__ + "static/firstday-a2c01c308a411a59dacc8c7288a9f3a1.jpg";